export const LOCK_SECTIONS = {
    DASHBOARDS: 'dashboards',
    REPORTS: 'reports',
    SCRIPTS: 'scripts',
    ELEMENTS: 'elements',
    STEP_GROUPS: 'stepGroups',
    PROGRAM_ELEMENTS: 'programElements',
    TEST_DATA: 'testData',
    SUITES: 'suites',
    WEB_SERVICE: 'webservice',
    DEFECTS: 'defects',
    FILES: 'files',
};
const ROUTE_LOCK_SECTION_MATCHERS = [
    { match: '/repository/step-group', section: LOCK_SECTIONS.STEP_GROUPS },
    {
        match: '/repository/program-elements',
        section: LOCK_SECTIONS.PROGRAM_ELEMENTS,
    },
    { match: '/repository/elements', section: LOCK_SECTIONS.ELEMENTS },
    { match: '/test-data', section: LOCK_SECTIONS.TEST_DATA },
    { match: '/test-dev', section: LOCK_SECTIONS.SCRIPTS },
    { match: '/suites', section: LOCK_SECTIONS.SUITES },
    { match: '/webservice', section: LOCK_SECTIONS.WEB_SERVICE },
    { match: '/defects', section: LOCK_SECTIONS.DEFECTS },
    { match: '/dashboard', section: LOCK_SECTIONS.DASHBOARDS },
];
export const resolveLockSectionFromRoute = (pathname = typeof window !== 'undefined' ? window.location.pathname : '') => {
    const path = pathname.split('?')[0];
    return (ROUTE_LOCK_SECTION_MATCHERS.find(({ match }) => path.includes(match))
        ?.section ?? null);
};
//# sourceMappingURL=lockSections.js.map